import {
  Asset,
  AnyContentType,
  NormalizedManager,
  NormalizedEntity,
} from '@stripe-internal/mkt-contentful';
import {createContext, useContext, useMemo} from 'react';

const NormalizedManagerContext = createContext<NormalizedManager | undefined>(
  undefined,
);

export function useNormalizedManager() {
  return useContext(NormalizedManagerContext);
}

export function useEntityId(
  entity: NormalizedEntity<Asset> | NormalizedEntity<AnyContentType>,
) {
  const manager = useNormalizedManager();
  return useMemo(
    () => manager?.getLink(entity)?.primary_key,
    [entity, manager],
  );
}

export const NormalizedManagerProvider = NormalizedManagerContext.Provider;
